export default {
  label: {
    xAxis: {
      title: 'Channel',
    },
    yAxis: {
      title: 'Respondents',
    },
    bubble: {
      replier: 'Name',
      channel: 'Channel',
      value: 'Value',
      total: 'Total',
    },
  },
};
